module.exports = __webpack_public_path__ + "static/media/google-inscription.2edf43b2.png";